import { promisify } from './helpers/promisify';
import { ValidateWith } from './types/ValidateWith';

/** Wraps all the validators into one validator. All of these validators are going to be executed asynchronously. */
export const validateWith: ValidateWith = (...validators) => (...params) =>
  new Promise(resolve => {
    const promises = validators.map(validator => {
      const promise = promisify(validator);
      return promise(...params);
    });
    Promise.all(promises)
      .then(() => resolve(undefined))
      .catch(resolve);
  });
